var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giftChatBox"},[_c('div',{staticClass:"name"},[_vm._v("\""+_vm._s(_vm.name)+"\"")]),_c('div',{staticClass:"action"},[_vm._v("送出一个鲜花")]),_c('div',{staticClass:"gift"},[_c('img',{attrs:{"src":_vm.giftImg,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }